module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAjCAYAAAAaLGNkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADDSURBVHgB7dexDcIwEIXhdwlCKTNCRqAMVBnBK7ABJYImTXpGYAIwE0AVxsBMgHsKY4QOBYmUTlzc10QnRfIv2c0RvLnangmoMLx9q5sllWpdJEhvGEsCf34EJt3BwZ0cpisEluJ5dMDsbwSBHlddGwTm36ClzhzFdUgEkwgmEUwimEQwiWASwSSCSQSTCCYRTCJYfLuoXwTVQm0qBEf5e/PtiXD554fQ3M+UZMis/xqMw7SH5v5djktVFxhYBmsvemdfN8ckja1DNhcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/checkbox.png
// module id = 2616
// module chunks = 0